import { useEffect, useMemo, useState } from 'react';

/** Same options as Unterrichtsverwaltung Seitenweise mode */
export const LIST_PAGE_SIZE_OPTIONS = [50, 100, 200, 500];

/**
 * Client-side list mode matching UV: 'all' (scroll everything) or 'paged'.
 * Data is assumed already loaded; this only slices for display.
 *
 * @param {unknown[]} items
 * @param {{ defaultMode?: 'all'|'paged', defaultPageSize?: number, resetKey?: string|number }} [opts]
 */
export function useClientListMode(items, {
  defaultMode = 'all',
  defaultPageSize = 100,
  resetKey,
} = {}) {
  const [listMode, setListMode] = useState(defaultMode);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [listPage, setListPage] = useState(1);

  const totalCount = Array.isArray(items) ? items.length : 0;
  const pageCount = Math.max(1, Math.ceil(totalCount / Math.max(1, pageSize)));

  useEffect(() => {
    setListPage(1);
  }, [resetKey, listMode, pageSize, totalCount]);

  useEffect(() => {
    if (listPage > pageCount) setListPage(pageCount);
  }, [listPage, pageCount]);

  const visibleItems = useMemo(() => {
    if (!Array.isArray(items)) return [];
    if (listMode === 'all') return items;
    const start = (listPage - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, listMode, listPage, pageSize]);

  return {
    listMode,
    setListMode,
    pageSize,
    setPageSize,
    listPage,
    setListPage,
    totalCount,
    pageCount,
    visibleItems,
  };
}
